/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_View_Audit_Log_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to view a record of who made which changes in this server." |
*
* @param {Leveling_Perm_View_Audit_Log_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_view_audit_log_hint = /** @type {((inputs?: Leveling_Perm_View_Audit_Log_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_View_Audit_Log_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам видеть, кто и какие изменения вносил на этом сервере.")
	return /** @type {LocalizedString} */ ("Allows members to view a record of who made which changes in this server.")
});